module.exports = __webpack_public_path__ + "img/blackPremiumStar.ef9ac34.svg";